import Vue from 'vue'
import VueRouter from 'vue-router'

import "../src/design/app.scss";

import App from './App.vue'

import store from './state/store'
import i18n from './i18n'
import router from './router/index'
import api from './services/api'

Vue.prototype.$http = api;

import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import VueScrollspy from 'vue2-scrollspy';
import Vuelidate from 'vuelidate'
import VueClickOutside from "v-click-outside"
import VueMoment from 'vue-moment'
import moment from 'moment'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import "@/design/app.scss";

Vue.use(VueRouter)
Vue.use(VueScrollspy);
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueClickOutside)
Vue.use(VueMoment)
Vue.use(VueLodash, {name: 'custom', lodash: lodash})
Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false
Vue.prototype.moment = moment

new Vue({
    router,
    store,
    beforeCreate() {
        this.$store.commit('initialiseStore');
    },
    i18n,
    fallbackLocale: 'en',
    render: h => h(App)
}).$mount('#app')
